module.exports = __webpack_public_path__ + "img/youtube.70d6af69.svg";